import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { WebRoutes, cn, useDebounce } from '@theprintbar/shared';
import { ProductQueryKeys, SearchIcon } from '@theprintbar/ui';
import React, { useEffect } from 'react';
import { useSearchBox } from 'react-instantsearch';

interface SearchInputProps {
	searchTerm: string;
	setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
	inMega?: boolean;
	inputRef?: React.RefObject<HTMLInputElement>;
}

let timerId: any = undefined;
let timeout = 200;
function queryHook(query: string, search: (query: string) => void) {
	if (timerId) {
		clearTimeout(timerId);
	}

	timerId = setTimeout(() => search(query), timeout);
}

const SearchInput: React.FC<SearchInputProps> = ({ searchTerm, setSearchTerm, inMega = false, inputRef }) => {
	const { refine } = useSearchBox({
		queryHook,
	});

	const handleSearchChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			setSearchTerm(e.target.value);
			refine(e.target.value);
		},
		[setSearchTerm],
	);

	return (
		<form action={WebRoutes.Products()} className="relative mt-2">
			<div className="relative mb-4">
				<input
					name={ProductQueryKeys.Search}
					type="text"
					placeholder="Search term..."
					value={searchTerm}
					className={cn(
						'lg:h-12 rounded-3xl border-blue px-3 my-1 lg:px-5 font-display font-light text-sm lg:text-xl placeholder:text-blue w-full bg-inherit',
						inMega ? 'h-10 font-sans font-normal' : 'h-8',
					)}
					onChange={handleSearchChange}
					ref={inputRef}
				/>
				<button type="submit" className="absolute inset-y-0 right-1 lg:right-2 px-1 flex items-center">
					<SearchIcon className="w-auto h-4 xl:w-auto xl:h-5 absolute storke-blue right-2 lg:right-4 top-1/2 -translate-y-1/2" />
				</button>
				{/* TODO: Add a clear button */}
			</div>
		</form>
	);
};

export default SearchInput;
